import { AgencyDetailHeader } from '@/modules/agencies/components/AgencyDetailHeader'
import { AgencyDetailOverview } from '@/modules/agencies/components/AgencyDetailOverview'
import { AgencyEditDrawer } from '@/modules/agencies/components/AgencyEditDrawer'
import { AgencyStatusConfirmDialog } from '@/modules/agencies/components/AgencyStatusConfirmDialog'
import { AgencyUserDrawer } from '@/modules/agencies/components/AgencyUserDrawer'
import { AgencyUsersSection } from '@/modules/agencies/components/AgencyUsersSection'
import {
  AgencyListError,
  AgencyListLoading,
} from '@/modules/agencies/components/AgencyListState'
import { useAgencyDetail } from '@/modules/agencies/hooks/useAgencyDetail'

export function AgencyDetailPage() {
  const {
    agency,
    isLoading,
    isError,
    errorMessage,
    isMissingId,
    statusAction,
    isStatusPending,
    onBack,
    onEdit,
    onStatusAction,
  } = useAgencyDetail()

  if (isMissingId) {
    return (
      <AgencyListError
        title="Missing agency"
        message="No agency id was provided in the URL."
      />
    )
  }

  if (isLoading) {
    return <AgencyListLoading label="Loading agency…" />
  }

  if (isError || !agency) {
    return (
      <section className="flex flex-col gap-6">
        <button
          type="button"
          onClick={onBack}
          className="w-fit border-2 border-ink px-3 py-2 text-sm font-semibold text-ink hover:bg-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        >
          ← Back to agencies
        </button>
        <AgencyListError
          title="Could not load agency"
          message={errorMessage ?? 'Agency not found.'}
        />
      </section>
    )
  }

  return (
    <section className="flex flex-col gap-6">
      <AgencyDetailHeader
        agency={agency}
        statusAction={statusAction}
        isStatusPending={isStatusPending}
        onBack={onBack}
        onEdit={onEdit}
        onStatusAction={onStatusAction}
      />
      <AgencyDetailOverview agency={agency} />
      <AgencyUsersSection agencyId={agency.id} />
      <AgencyEditDrawer />
      <AgencyUserDrawer />
      <AgencyStatusConfirmDialog />
    </section>
  )
}
